import { Button, buttonVariants } from "@/components/ui/button";
import { Pencil } from "lucide-react";
import { GetPresentationResponseType } from "../../../hooks/useGetPresentation";
import { Label } from "@/components/ui/label";
import DeletePresentationButton from "./deleteButton";
import DuplicatePresentationButton from "./duplicateButton";
import { useStorage } from "@/features/storage/useStorage";
import { t } from "@/lib/localization";

export default function PresentationSheetHeader({
    presentation,
}: {
    presentation: GetPresentationResponseType["data"];
}) {
    const setOpen = useStorage((state) => state.setPresentationSheetOpen);

    return (
        <header className="bg-white px-8 flex flex-row h-16 w-full justify-between items-center border-b">
            <div className="truncate flex flex-col">
                <Label className="truncate text-base">
                    {presentation?.name
                        ? t("presentation-sheet.header.title", undefined, { presentationName: presentation.name })
                        : t("presentation-sheet.header.title.placeholder", undefined, undefined)}
                </Label>

                {!!presentation?.folders.length && (
                    <p
                        className="truncate text-xs text-muted-foreground"
                        title={presentation.folders
                            .map((f) => f.name)
                            .join(", ")}
                    >
                        {t("presentation-sheet.header.folders", undefined, {
                                folderNames: presentation.folders
                                    .map((f) => f.name)
                                    .join(", "),
                            })}
                    </p>
                )}
            </div>

            <div className="hidden md:flex flex-row gap-2">
                <DeletePresentationButton presentation={presentation} />
                <DuplicatePresentationButton presentation={presentation} />
                <a
                    onClick={() => {
                        setOpen(false);
                    }}
                    href={`/recorder/${presentation.id}`}
                    className={buttonVariants({
                        variant: "secondary",
                        size: "sm",
                    })}
                >
                    <Pencil className="size-3.5 me-2" />
                    {t("presentation-sheet.header.edit-btn", undefined, undefined)}
                </a>
            </div>
        </header>
    );
}
